import { CompareArrows } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import ComparadorTextos from '@/components/shared/ComparadorTextos';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../../../ReactComponent';

class ComparacaoDecisaoRascunhoCertidao extends ReactComponent {
    openDialog = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            openDialog: observable,
            registro: computed,
            handleOpenDialog: action,
            handleCloseDialog: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    handleOpenDialog = () => {
        this.openDialog = true;
    };

    handleCloseDialog = () => {
        this.openDialog = false;
    };

    render() {
        return (
            <Box>
                <Tooltip
                    title="Exibir comparação de Decisão e Rascunho da certidão"
                    placement="top-start"
                >
                    <Box component="span">
                        <Button
                            size="small"
                            color="primary"
                            variant="contained"
                            sx={{
                                zIndex: 9999,
                                textTransform: 'none'
                            }}
                            onClick={this.handleOpenDialog}
                        >
                            <CompareArrows sx={{ fontSize: '24px', pr: 0.5 }} /> Comparar com Decisão
                        </Button>
                    </Box>
                </Tooltip>

                <Dialog
                    open={!!this.openDialog}
                    onClose={this.handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="xl"
                >
                    <DialogTitle id="alert-dialog-title">
                        Comparação de conteúdo da Decisão e do Rascunho da Certidão
                    </DialogTitle>
                    <DialogContent>
                        <ComparadorTextos
                            conteudoAntigo={this.registro.decisao ?? ''}
                            conteudoNovo={this.registro.rascunhoCertidao ?? ''}
                            labelConteudoAntigo="Decisão"
                            labelConteudoNovo="Rascunho da Certidão"
                        />
                    </DialogContent>
                    <DialogActions sx={{ pr: 3, pb: 1 }}>
                        <Button
                            color="primary"
                            onClick={this.handleCloseDialog}
                            variant="contained"
                            endIcon={<CloseIcon />}
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        );
    }
}

export default inject('stores')(observer(ComparacaoDecisaoRascunhoCertidao));
